import Vue from 'vue'
import Echo from 'laravel-echo'
import 'pusher-js'
import * as VueGoogleMaps from 'vue2-google-maps'
// import * as VueGoogleMaps from 'gmap-vue'
import store from '@/store'
import {urls as apiUrls} from '@/api'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAqc77TbIiL3k7GgevMEv-9x3jpyMSe14s',
    libraries: 'places',
    region: 'es-419',
    language: 'es-419'
  }
})

export const urls = {
  // get client IP
  ip: 'https://api.ipify.org?format=json', // no necesario
  // get city name from coords
  googlegeo: 'https://maps.googleapis.com/maps/api/geocode/json',
  // get location from client IP - Free API (no API key needed)
  geolocation: 'https://ipapi.co/json/'
}

/**
 * Evita los problemas de axios mandando el header Authorization.
 */
export const getGoogleGeo = ({lat, lon}) => {
  const params = {
    latlng: `${lat},${lon}`,
    key: 'AIzaSyAqc77TbIiL3k7GgevMEv-9x3jpyMSe14s',
    language: 'es-419'
  }
  const query = Object.entries(params).map(([key, val]) => `${key}=${val}`).join('&')

  return fetch(`${urls.googlegeo}?${query}`)
    .then(res => res.json())
    .then(data => ({ data }))
}

export const notifications = {
  init: attrs => {
    const userId = store.state.user.id
    const bearer = store.state.user.bearer
    const isAuth = store.state.user.isAuth

    // Chequeo de autenticación antes de inicializar websockets o suscribirse a canales privados
    if (!isAuth || !userId || !bearer) {
      return null
    }

    const ws = new Echo({
      authEndpoint: apiUrls.ws,
      broadcaster: 'pusher',
      key: 'QEFSGXCV',
      encrypted: true,
      disableStats: true,
      wsHost: 'ws.maspocovendo.com', // Using reverse proxy instead
      // wsPort: 6001,
      // wssPort: 6001,
      forceTLS: true,
      enabledTransports: ['ws', 'wss'],
      auth: {
        headers: {
          Authorization: 'Bearer ' + bearer
        }
      }
    })

    return ws.private('App.Http.Modules.User.UserModuleMe.' + userId)
      .notification(({data}) => {
        store.dispatch('user/addNotification', data)
        if (data.type === 'question') {
          store.dispatch('user/addNewUnansweredQuestion')
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/services.js